export const translateVehicleEquipmentCategory = (name: string): string => {
  switch (name.toLowerCase()) {
    case 'securite':
      return 'Sécurité';
    case 'exterieur et chassis':
      return 'Extérieur et Chassis';
    case 'interieur':
      return 'Intérieur';
    case 'antivol':
      return 'Antivol';
    case 'confort':
      return 'Confort';
    case 'autre':
      return 'Autre';
    default:
      return name;
  }
};
